import Chartkick from "chartkick";
import htmlToLabel from "./htmlToLabel";

Chartkick.options = {
  colors: ["blue"],
};

const treatAsUTC = (date) => {
  let result = new Date(date);
  result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
  return result;
};

const daysBetween = (startDate, endDate) => {
  const millisecondsPerDay = 24 * 60 * 60 * 1000;
  return (treatAsUTC(endDate) - treatAsUTC(startDate)) / millisecondsPerDay;
};

/**
 * Returns comparison period range { range_start, range_end } as ISO strings.
 * Comparison period is the equal-length period immediately before the current period.
 */
const getComparisonRange = (range_start, range_end) => {
  const start = new Date(range_start);
  const end = new Date(range_end);
  if (isNaN(start.getTime()) || isNaN(end.getTime())) return null;
  const durationMs = end.getTime() - start.getTime();
  const comparisonEnd = new Date(start.getTime() - 1000);
  const comparisonStart = new Date(comparisonEnd.getTime() - durationMs);
  return {
    range_start: comparisonStart.toISOString(),
    range_end: comparisonEnd.toISOString(),
  };
};

const fieldReportFallback = (field) => {
  const options = field.options || {};
  return (
    htmlToLabel(field.label || "").trim() ||
    htmlToLabel(options["description"] || "").trim() ||
    (field.field_type === "empty"
      ? "Show a Message"
      : field.slug || field.field_type)
  );
};

const fieldReportLabel = (field) =>
  ((field.options || {})["report-label"] || "").trim() ||
  fieldReportFallback(field);

const ReportsHelpers = {
  getComparisonRange,
  fieldReportFallback,
  fieldReportLabel,
  getGroupBy: (timeframe, range_start, range_end) => {
    const timeframeTypes = {
      "All Time": "year",
      Today: "day",
      Yesterday: "day",
      "This Week": "day",
      "This Month": "week",
      "This Quarter": "month",
      "This Year": "month",
      "Last 24 Hours": "day",
      "Last 7 Days": "day",
      "Last 30 Days": "week",
      "Last 90 Days": "week",
      "Last 365 Days": "month",
    };

    if (timeframeTypes[timeframe]) {
      return timeframeTypes[timeframe];
    } else {
      const difference = daysBetween(range_start, range_end);
      console.log("difference", difference);

      if (difference < 8) {
        return "day";
      } else if (difference < 32) {
        return "week";
      } else if (difference < 93) {
        return "month";
      } else if (difference > 365) {
        return "year";
      } else {
        return "month";
      }
    }
  },
};

export default ReportsHelpers;
